import { Link, useLocation } from 'react-router-dom';
import Logo from '../../../assets/images/grhamDeal-logo.png';
import { usePermissions } from '../../../utils/Permission/Permission';
import { useEffect, useState } from 'react';
import * as bootstrap from 'bootstrap';

declare global {
  interface Window {
    bootstrap?: any;
  }
}

export type NavSidebarTopic = {
  title: string;
  subTopics?: NavSidebarTopic[];
  to: string;
  icon: JSX.Element;
  hasAccess?: boolean;
};

// List objects for routes

function DashboardNavbar(props: any) {
  const location = useLocation();
  const { hasPermission } = usePermissions();
  const [openMenu, setOpenMenu] = useState<string | null>(null);

  // Update the closeSidebar function
  const closeSidebar = () => {
    const sidebar = document.getElementById('FHL-Sidebar-menu');
    if (sidebar) {
      const bsOffcanvas =
        bootstrap.Offcanvas.getInstance(sidebar) ||
        new bootstrap.Offcanvas(sidebar);
      bsOffcanvas.hide();
    }
  };

  // Add this useEffect to initialize Bootstrap
  useEffect(() => {
    // Initialize offcanvas when component mounts
    const sidebar = document.getElementById('FHL-Sidebar-menu');
    if (sidebar) {
      new bootstrap.Offcanvas(sidebar, {
        backdrop: false,
        scroll: true,
      });
    }

    // Cleanup on unmount
    return () => {
      const sidebar = document.getElementById('FHL-Sidebar-menu');
      if (sidebar) {
        const bsOffcanvas = bootstrap.Offcanvas.getInstance(sidebar);
        if (bsOffcanvas) {
          bsOffcanvas.dispose();
        }
      }
    };
  }, []);

  return (
    <aside
      id="FHL-Sidebar-menu"
      className="offcanvas-lg offcanvas-start"
      data-bs-scroll="true"
      data-bs-backdrop="false"
    >
      <div className="offcanvas-header">
        <Link to="/" className="logo mx-auto" onClick={closeSidebar}>
          <img src={Logo} alt="logo" className="img-fluid" />
        </Link>
        <button
          type="button"
          className="btn-close d-lg-none"
          data-bs-toggle="offcanvas"
          data-bs-target="#FHL-Sidebar-menu"
          aria-label="Close"
        ></button>
      </div>
      <div className="offcanvas-body">
        <ul>
          <li>
            <Link
              to="/dashboard"
              className={location.pathname === '/dashboard' ? 'active' : ''}
              onClick={closeSidebar}
            >
              <svg
                stroke="currentColor"
                fill="currentColor"
                strokeWidth="0"
                viewBox="0 0 24 24"
                height="1em"
                width="1em"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path fill="none" d="M0 0h24v24H0z"></path>
                <path d="M11 11V3H5c-1.1 0-2 .9-2 2v6h8zm2 0h8V5c0-1.1-.9-2-2-2h-6v8zm-2 2H3v6c0 1.1.9 2 2 2h6v-8zm2 0v8h6c1.1 0 2-.9 2-2v-6h-8z"></path>
              </svg>
              Dashboard
            </Link>
          </li>
          {hasPermission('admin.owner') ? (
            <li>
              <Link
                to="/dashboard/listing"
                className={
                  location.pathname === '/dashboard/listing' ? 'active' : ''
                }
                onClick={closeSidebar}
              >
                <svg
                  stroke="currentColor"
                  fill="currentColor"
                  strokeWidth="0"
                  viewBox="0 0 512 512"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill="none"
                    strokeLinejoin="round"
                    strokeWidth="32"
                    d="M416 221.25V416a48 48 0 0 1-48 48H144a48 48 0 0 1-48-48V96a48 48 0 0 1 48-48h98.75a32 32 0 0 1 22.62 9.37l141.26 141.26a32 32 0 0 1 9.37 22.62z"
                  ></path>
                  <path
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="32"
                    d="M256 56v120a32 32 0 0 0 32 32h120m-232 80h160m-160 80h160"
                  ></path>
                </svg>
                {hasPermission('admin') ? 'All Properties' : 'My Properties'}
              </Link>
            </li>
          ) : (
            <></>
          )}

          {/* {hasPermission('admin.owner') ? (
            <li>
              <button
                className="btn"
                type="button"
                onClick={() =>
                  setOpenMenu(openMenu === 'Properties' ? null : 'Properties')
                }
              >
                <svg
                  stroke="currentColor"
                  fill="currentColor"
                  strokeWidth="0"
                  viewBox="0 0 24 24"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M7 14.001h2v2H7z"></path>
                  <path d="M19 2h-8a2 2 0 0 0-2 2v6H5c-1.103 0-2 .897-2 2v9a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a2 2 0 0 0-2-2zM5 20v-8h6v8H5zm9-12h-2V6h2v2zm4 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V6h2v2z"></path>
                </svg>
                Properties
                <svg
                  className={`menus-arrow${
                    openMenu === 'Properties' ? ' open' : ''
                  }`}
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 -960 960 960"
                  width="24"
                >
                  <path d="M480-358.463 253.847-584.615 296-626.768l184 184 184-184 42.153 42.153L480-358.463Z" />
                </svg>
              </button>
              <div
                className={`collapse ${
                  openMenu === 'Properties' ? 'show' : ''
                }`}
                id="Properties"
              >
                <ul>
                  <li>
                    <Link
                      to="/dashboard/add-listing"
                      className={
                        location.pathname === '/dashboard/add-listing'
                          ? 'active'
                          : ''
                      }
                      onClick={closeSidebar}
                    >
                      <svg
                        stroke="currentColor"
                        fill="currentColor"
                        strokeWidth="0"
                        viewBox="0 0 512 512"
                        height="1em"
                        width="1em"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M346.5 240H272v-74.5c0-8.8-7.2-16-16-16s-16 7.2-16 16V240h-74.5c-8.8 0-16 6-16 16s7.5 16 16 16H240v74.5c0 9.5 7 16 16 16s16-7.2 16-16V272h74.5c8.8 0 16-7.2 16-16s-7.2-16-16-16z"></path>
                        <path d="M256 76c48.1 0 93.3 18.7 127.3 52.7S436 207.9 436 256s-18.7 93.3-52.7 127.3S304.1 436 256 436c-48.1 0-93.3-18.7-127.3-52.7S76 304.1 76 256s18.7-93.3 52.7-127.3S207.9 76 256 76m0-28C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48z"></path>
                      </svg>
                      Create Listing
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/dashboard/listing"
                      className={
                        location.pathname === '/dashboard/listing'
                          ? 'active'
                          : ''
                      }
                      onClick={closeSidebar}
                    >
                      <svg
                        stroke="currentColor"
                        fill="currentColor"
                        strokeWidth="0"
                        viewBox="0 0 512 512"
                        height="1em"
                        width="1em"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill="none"
                          strokeLinejoin="round"
                          strokeWidth="32"
                          d="M416 221.25V416a48 48 0 0 1-48 48H144a48 48 0 0 1-48-48V96a48 48 0 0 1 48-48h98.75a32 32 0 0 1 22.62 9.37l141.26 141.26a32 32 0 0 1 9.37 22.62z"
                        ></path>
                        <path
                          fill="none"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="32"
                          d="M256 56v120a32 32 0 0 0 32 32h120m-232 80h160m-160 80h160"
                        ></path>
                      </svg>
                      {hasPermission('admin')
                        ? 'All Properties'
                        : 'My Properties'}
                    </Link>
                  </li>
                </ul>
              </div>
            </li>
          ) : (
            <></>
          )} */}

          {hasPermission('admin') ? (
            <li>
              <button
                className="btn"
                type="button"
                onClick={() => setOpenMenu(openMenu === 'Blog' ? null : 'Blog')}
              >
                <span className="material-symbols-outlined">article</span>
                Blog
                <svg
                  className={`menus-arrow${openMenu === 'Blog' ? ' open' : ''}`}
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 -960 960 960"
                  width="24"
                >
                  <path d="M480-358.463 253.847-584.615 296-626.768l184 184 184-184 42.153 42.153L480-358.463Z" />
                </svg>
              </button>
              <div
                className={`collapse ${openMenu === 'Blog' ? 'show' : ''}`}
                id="Blog"
              >
                <ul>
                  <li>
                    <Link
                      to="/dashboard/create-blog"
                      className={
                        location.pathname === '/dashboard/create-blog'
                          ? 'active'
                          : ''
                      }
                      onClick={closeSidebar}
                    >
                      <svg
                        stroke="currentColor"
                        fill="currentColor"
                        strokeWidth="0"
                        viewBox="0 0 512 512"
                        height="1em"
                        width="1em"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M346.5 240H272v-74.5c0-8.8-7.2-16-16-16s-16 7.2-16 16V240h-74.5c-8.8 0-16 6-16 16s7.5 16 16 16H240v74.5c0 9.5 7 16 16 16s16-7.2 16-16V272h74.5c8.8 0 16-7.2 16-16s-7.2-16-16-16z"></path>
                        <path d="M256 76c48.1 0 93.3 18.7 127.3 52.7S436 207.9 436 256s-18.7 93.3-52.7 127.3S304.1 436 256 436c-48.1 0-93.3-18.7-127.3-52.7S76 304.1 76 256s18.7-93.3 52.7-127.3S207.9 76 256 76m0-28C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48z"></path>
                      </svg>
                      Create Blog
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/dashboard/blog-list"
                      className={
                        location.pathname === '/dashboard/blog-list'
                          ? 'active'
                          : ''
                      }
                      onClick={closeSidebar}
                    >
                      <svg
                        stroke="currentColor"
                        fill="currentColor"
                        strokeWidth="0"
                        viewBox="0 0 512 512"
                        height="1em"
                        width="1em"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill="none"
                          strokeLinejoin="round"
                          strokeWidth="32"
                          d="M416 221.25V416a48 48 0 0 1-48 48H144a48 48 0 0 1-48-48V96a48 48 0 0 1 48-48h98.75a32 32 0 0 1 22.62 9.37l141.26 141.26a32 32 0 0 1 9.37 22.62z"
                        ></path>
                        <path
                          fill="none"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="32"
                          d="M256 56v120a32 32 0 0 0 32 32h120m-232 80h160m-160 80h160"
                        ></path>
                      </svg>
                      Blog List
                    </Link>
                  </li>
                </ul>
              </div>
            </li>
          ) : (
            <></>
          )}

          {hasPermission('admin') ? (
            <li>
              <button
                className="btn"
                type="button"
                onClick={() => setOpenMenu(openMenu === 'User' ? null : 'User')}
              >
                <svg
                  width="1em"
                  height="1em"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="User / Users">
                    <path
                      id="Vector"
                      d="M21 19.9999C21 18.2583 19.3304 16.7767 17 16.2275M15 20C15 17.7909 12.3137 16 9 16C5.68629 16 3 17.7909 3 20M15 13C17.2091 13 19 11.2091 19 9C19 6.79086 17.2091 5 15 5M9 13C6.79086 13 5 11.2091 5 9C5 6.79086 6.79086 5 9 5C11.2091 5 13 6.79086 13 9C13 11.2091 11.2091 13 9 13Z"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </g>
                </svg>
                Users
                <svg
                  className={`menus-arrow${openMenu === 'User' ? ' open' : ''}`}
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 -960 960 960"
                  width="24"
                >
                  <path d="M480-358.463 253.847-584.615 296-626.768l184 184 184-184 42.153 42.153L480-358.463Z" />
                </svg>
              </button>
              <div
                className={`collapse ${openMenu === 'User' ? 'show' : ''}`}
                id="Users"
              >
                <ul>
                  <li>
                    <Link
                      to="/dashboard/tenants"
                      className={
                        location.pathname === '/dashboard/tenants'
                          ? 'active'
                          : ''
                      }
                      onClick={closeSidebar}
                    >
                      <svg
                        width="1em"
                        height="1em"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16.5 22.5H18.75C19.1478 22.5 19.5294 22.342 19.8107 22.0607C20.092 21.7794 20.25 21.3978 20.25 21V13.5"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M7.5 22.5H5.25C4.85218 22.5 4.47064 22.342 4.18934 22.0607C3.90804 21.7794 3.75 21.3978 3.75 21V13.5"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M0.75 12.129L10.939 1.939C11.0783 1.79961 11.2437 1.68904 11.4258 1.61359C11.6078 1.53815 11.8029 1.49932 12 1.49932C12.1971 1.49932 12.3922 1.53815 12.5742 1.61359C12.7563 1.68904 12.9217 1.79961 13.061 1.939L23.122 12"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M12 12C13.2426 12 14.25 10.9926 14.25 9.75C14.25 8.50736 13.2426 7.5 12 7.5C10.7574 7.5 9.75 8.50736 9.75 9.75C9.75 10.9926 10.7574 12 12 12Z"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M12 13.5C11.0054 13.5 10.0516 13.8951 9.34835 14.5983C8.64509 15.3016 8.25 16.2554 8.25 17.25V18H9.75L10.5 22.5H13.5L14.25 18H15.75V17.25C15.75 16.2554 15.3549 15.3016 14.6517 14.5983C13.9484 13.8951 12.9946 13.5 12 13.5Z"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      Tenants
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/dashboard/owners"
                      className={
                        location.pathname === '/dashboard/owners'
                          ? 'active'
                          : ''
                      }
                      onClick={closeSidebar}
                    >
                      <svg
                        version="1.0"
                        xmlns="http://www.w3.org/2000/svg"
                        width="1em"
                        height="1em"
                        viewBox="0 0 50.000000 50.000000"
                        preserveAspectRatio="xMidYMid meet"
                      >
                        <metadata>
                          Created by potrace 1.10, written by Peter Selinger
                          2001-2011
                        </metadata>
                        <g
                          transform="translate(0.000000,50.000000) scale(0.100000,-0.100000)"
                          fill="currentColor"
                          stroke="none"
                        >
                          <path
                            d="M183 450 c-12 -5 -29 -20 -37 -33 -22 -33 -18 -142 6 -182 32 -53 25
                      -73 -36 -100 -55 -24 -86 -56 -86 -87 0 -17 14 -18 165 -18 103 0 165 4 165
                      10 0 6 -23 10 -50 10 -45 0 -52 3 -60 26 -15 37 -12 51 5 28 15 -19 15 -19 33
                      3 13 15 23 18 33 12 8 -5 20 -9 27 -9 23 0 12 16 -23 33 -40 19 -44 39 -17 95
                      18 36 27 129 17 163 -7 22 -69 59 -98 58 -12 0 -32 -4 -44 -9z m80 -26 c18 -9
                      35 -22 39 -28 9 -13 6 -126 -3 -126 -4 0 -13 -21 -20 -46 -24 -81 -74 -81 -98
                      0 -7 25 -16 46 -20 46 -4 0 -8 26 -8 58 -2 64 14 98 49 105 13 2 24 5 26 6 2
                      0 17 -6 35 -15z m-57 -275 c8 -14 -11 -33 -25 -25 -11 7 -4 36 9 36 5 0 12 -5
                      16 -11z m-1 -45 c17 23 20 9 5 -28 -9 -25 -13 -26 -85 -26 -73 0 -75 1 -65 21
                      6 11 30 28 53 38 41 17 42 17 59 -3 18 -21 18 -21 33 -2z"
                          />
                          <path
                            d="M365 275 c-30 -29 -32 -73 -6 -107 14 -17 21 -44 23 -88 3 -70 22
                      -95 56 -74 13 9 17 26 18 73 1 45 7 67 20 82 28 31 25 96 -5 120 -32 27 -77
                      24 -106 -6z m95 -15 c11 -11 20 -29 20 -40 0 -11 -9 -29 -20 -40 -11 -11 -29
                      -20 -40 -20 -26 0 -60 34 -60 60 0 11 9 29 20 40 11 11 29 20 40 20 11 0 29
                      -9 40 -20z m-25 -149 c0 -16 -3 -33 -7 -37 -4 -4 -3 -13 4 -21 8 -10 8 -17 0
                      -25 -19 -19 -32 3 -32 58 0 45 3 54 18 54 12 0 17 -8 17 -29z"
                          />
                          <path
                            d="M404 249 c-10 -17 13 -36 27 -22 12 12 4 33 -11 33 -5 0 -12 -5 -16
                      -11z"
                          />
                        </g>
                      </svg>
                      Owner
                    </Link>
                  </li>
                </ul>
              </div>
            </li>
          ) : (
            <></>
          )}

          {/* {hasPermission('owner') ? (
            <li>
              <Link
                to="/dashboard/tenants"
                className={
                  location.pathname === '/dashboard/tenants' ? 'active' : ''
                }
                onClick={closeSidebar}
              >
                <svg
                  width="1em"
                  height="1em"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.5 22.5H18.75C19.1478 22.5 19.5294 22.342 19.8107 22.0607C20.092 21.7794 20.25 21.3978 20.25 21V13.5"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M7.5 22.5H5.25C4.85218 22.5 4.47064 22.342 4.18934 22.0607C3.90804 21.7794 3.75 21.3978 3.75 21V13.5"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M0.75 12.129L10.939 1.939C11.0783 1.79961 11.2437 1.68904 11.4258 1.61359C11.6078 1.53815 11.8029 1.49932 12 1.49932C12.1971 1.49932 12.3922 1.53815 12.5742 1.61359C12.7563 1.68904 12.9217 1.79961 13.061 1.939L23.122 12"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M12 12C13.2426 12 14.25 10.9926 14.25 9.75C14.25 8.50736 13.2426 7.5 12 7.5C10.7574 7.5 9.75 8.50736 9.75 9.75C9.75 10.9926 10.7574 12 12 12Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M12 13.5C11.0054 13.5 10.0516 13.8951 9.34835 14.5983C8.64509 15.3016 8.25 16.2554 8.25 17.25V18H9.75L10.5 22.5H13.5L14.25 18H15.75V17.25C15.75 16.2554 15.3549 15.3016 14.6517 14.5983C13.9484 13.8951 12.9946 13.5 12 13.5Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                My Tenants
              </Link>
            </li>
          ) : (
            <></>
          )} */}

          {hasPermission('admin.owner') && (
            <>
              {/* <li>
                <Link
                  to="/dashboard/finance"
                  className={
                    location.pathname === '/dashboard/finance' ? 'active' : ''
                  }
                >
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    strokeWidth="0"
                    viewBox="0 0 640 512"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM48 400v-64c35.35 0 64 28.65 64 64H48zm0-224v-64h64c0 35.35-28.65 64-64 64zm272 176c-44.19 0-80-42.99-80-96 0-53.02 35.82-96 80-96s80 42.98 80 96c0 53.03-35.83 96-80 96zm272 48h-64c0-35.35 28.65-64 64-64v64zm0-224c-35.35 0-64-28.65-64-64h64v64z"></path>
                  </svg>
                  Finance
                </Link>
              </li> */}
              {hasPermission('owner') && (
                <li>
                  <Link
                    to="/dashboard/Package"
                    className={
                      location.pathname === '/dashboard/Package' ? 'active' : ''
                    }
                    onClick={closeSidebar}
                  >
                    <svg
                      stroke="currentColor"
                      fill="currentColor"
                      strokeWidth="0"
                      viewBox="0 0 24 24"
                      height="1em"
                      width="1em"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M17.813 3.838A2 2 0 0 0 16.187 3H7.813c-.644 0-1.252.313-1.667.899l-4 6.581a.999.999 0 0 0 .111 1.188l9 10a.995.995 0 0 0 1.486.001l9-10a.997.997 0 0 0 .111-1.188l-4.041-6.643zM12 19.505 5.245 12h13.509L12 19.505zM4.777 10l3.036-5 8.332-.062L19.222 10H4.777z"></path>
                    </svg>
                    Package
                  </Link>
                </li>
              )}
              {/* <li>
                <Link
                  to="/dashboard/package"
                  className={
                    location.pathname === '/dashboard/package' ? 'active' : ''
                  }
                >
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    strokeWidth="0"
                    viewBox="0 0 24 24"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M22 8a.76.76 0 0 0 0-.21v-.08a.77.77 0 0 0-.07-.16.35.35 0 0 0-.05-.08l-.1-.13-.08-.06-.12-.09-9-5a1 1 0 0 0-1 0l-9 5-.09.07-.11.08a.41.41 0 0 0-.07.11.39.39 0 0 0-.08.1.59.59 0 0 0-.06.14.3.3 0 0 0 0 .1A.76.76 0 0 0 2 8v8a1 1 0 0 0 .52.87l9 5a.75.75 0 0 0 .13.06h.1a1.06 1.06 0 0 0 .5 0h.1l.14-.06 9-5A1 1 0 0 0 22 16V8zm-10 3.87L5.06 8l2.76-1.52 6.83 3.9zm0-7.72L18.94 8 16.7 9.25 9.87 5.34zM4 9.7l7 3.92v5.68l-7-3.89zm9 9.6v-5.68l3-1.68V15l2-1v-3.18l2-1.11v5.7z"></path>
                  </svg>
                  Package
                </Link>
              </li>{' '} */}
            </>
          )}

          {hasPermission('owner') && (
            <>
              <li>
                <Link
                  to="/dashboard/request"
                  className={
                    location.pathname === '/dashboard/request' ? 'active' : ''
                  }
                  onClick={closeSidebar}
                >
                  <svg
                    height="1em"
                    width="1em"
                    version="1.1"
                    id="Capa_1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    viewBox="0 0 197.896 197.896"
                    xmlSpace="preserve"
                  >
                    <g>
                      <g>
                        <polygon
                          fill="currentColor"
                          points="91.511,23.195 91.511,28.205 192.893,28.205 192.893,169.691 91.511,169.691 
                        91.511,174.702 197.896,174.702 197.896,23.195 		"
                        />
                        <polygon
                          fill="currentColor"
                          points="103.722,147.302 108.661,152.244 161.961,98.944 108.661,45.645 103.722,50.58 
                        148.587,95.448 0,95.448 0,102.437 148.583,102.437 		"
                        />
                      </g>
                    </g>
                  </svg>
                  Housing Request
                </Link>
              </li>

              <li>
                <Link
                  to="/dashboard/transactions"
                  className={
                    location.pathname === '/dashboard/transactions'
                      ? 'active'
                      : ''
                  }
                  onClick={closeSidebar}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="1em"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M2 4h20v2H2zM2 8h20v12H2zM4 10v2h4v-2z" />
                  </svg>
                  Transactions
                </Link>
              </li>
              {/* <li>
                <Link
                  to="/dashboard/package"
                  className={
                    location.pathname === '/dashboard/package' ? 'active' : ''
                  }
                >
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    strokeWidth="0"
                    viewBox="0 0 24 24"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M22 8a.76.76 0 0 0 0-.21v-.08a.77.77 0 0 0-.07-.16.35.35 0 0 0-.05-.08l-.1-.13-.08-.06-.12-.09-9-5a1 1 0 0 0-1 0l-9 5-.09.07-.11.08a.41.41 0 0 0-.07.11.39.39 0 0 0-.08.1.59.59 0 0 0-.06.14.3.3 0 0 0 0 .1A.76.76 0 0 0 2 8v8a1 1 0 0 0 .52.87l9 5a.75.75 0 0 0 .13.06h.1a1.06 1.06 0 0 0 .5 0h.1l.14-.06 9-5A1 1 0 0 0 22 16V8zm-10 3.87L5.06 8l2.76-1.52 6.83 3.9zm0-7.72L18.94 8 16.7 9.25 9.87 5.34zM4 9.7l7 3.92v5.68l-7-3.89zm9 9.6v-5.68l3-1.68V15l2-1v-3.18l2-1.11v5.7z"></path>
                  </svg>
                  Package
                </Link>
              </li>{' '} */}
            </>
          )}

          {/* {hasPermission('tenant') ? (
            <li>
              <button
                className="btn"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#Documents"
                aria-expanded="false"
                aria-controls="Documents"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="1em"
                  viewBox="0 -960 960 960"
                  width="1em"
                  fill="currentColor"
                >
                  <path d="M170-180q-29.15 0-49.58-20.42Q100-220.85 100-250v-457.69q0-29.15 21.58-50.73T172.31-780h219.61l80 80h315.77q26.85 0 46.31 17.35 19.46 17.34 22.54 42.65H447.38l-80-80H172.31q-5.39 0-8.85 3.46t-3.46 8.85v455.38q0 4.23 2.12 6.92 2.11 2.7 5.57 4.62L261-552.31h666.31l-96.85 322.62q-6.85 22.53-25.65 36.11Q786-180 763.08-180H170Zm60.54-60h540.23l75.46-252.31H306L230.54-240Zm0 0L306-492.31 230.54-240ZM160-640V-720v80Z" />
                </svg>
                Documents
                <svg
                  className="menus-arrow"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 -960 960 960"
                  width="24"
                >
                  <path d="M480-358.463 253.847-584.615 296-626.768l184 184 184-184 42.153 42.153L480-358.463Z" />
                </svg>
              </button>
              <div className="collapse" id="Documents">
                <ul>
                  <li>
                    <Link
                      to="/dashboard/licenses"
                      className={
                        location.pathname === '/dashboard/licenses'
                          ? 'active'
                          : ''
                      }
                      onClick={closeSidebar}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="1em"
                        viewBox="0 -960 960 960"
                        width="1em"
                        fill="currentColor"
                      >
                        <path d="M480-460q-41.92 0-70.96-29.04Q380-518.08 380-560q0-41.92 29.04-70.96Q438.08-660 480-660q41.92 0 70.96 29.04Q580-601.92 580-560q0 41.92-29.04 70.96Q521.92-460 480-460ZM260-70.77v-286.31q-38-39.69-59-91.85-21-52.15-21-111.07 0-125.62 87.17-212.81T479.94-860q125.6 0 212.83 87.19Q780-685.62 780-560q0 58.92-21 111.07-21 52.16-59 91.85v286.31l-220-70-220 70ZM480-320q100 0 170-70t70-170q0-100-70-170t-170-70q-100 0-170 70t-70 170q0 100 70 170t170 70ZM320-158.62l160-42.92 160 42.92v-148.61q-34.23 22.31-75.01 34.77Q524.22-260 479.92-260q-44.3 0-85-12.46-40.69-12.46-74.92-34.77v148.61Zm160-74.3Z" />
                      </svg>
                      Licenses
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/dashboard/certificates"
                      className={
                        location.pathname === '/dashboard/certificates'
                          ? 'active'
                          : ''
                      }
                      onClick={closeSidebar}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="1em"
                        viewBox="0 -960 960 960"
                        width="1em"
                        fill="currentColor"
                      >
                        <path d="M212.31-140Q182-140 161-161q-21-21-21-51.31v-535.38Q140-778 161-799q21-21 51.31-21h535.38Q778-820 799-799q21 21 21 51.31v535.38Q820-182 799-161q-21 21-51.31 21H212.31ZM200-747.69v535.38q0 4.62 3.85 8.46 3.84 3.85 8.46 3.85h535.38q4.62 0 8.46-3.85 3.85-3.84 3.85-8.46v-535.38q0-4.62-3.85-8.46-3.84-3.85-8.46-3.85H670v262.31l-90-53.85-90 53.85V-760H212.31q-4.62 0-8.46 3.85-3.85 3.84-3.85 8.46ZM200-200v-560 560Z" />
                      </svg>
                      Certificates
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/dashboard/CEUs"
                      className={
                        location.pathname === '/dashboard/CEUs' ? 'active' : ''
                      }
                      onClick={closeSidebar}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="1em"
                        viewBox="0 -960 960 960"
                        width="1em"
                        fill="currentColor"
                      >
                        <path d="M330-250h300v-60H330v60Zm0-160h300v-60H330v60Zm-77.69 310Q222-100 201-121q-21-21-21-51.31v-615.38Q180-818 201-839q21-21 51.31-21H570l210 210v477.69Q780-142 759-121q-21 21-51.31 21H252.31ZM540-620v-180H252.31q-4.62 0-8.46 3.85-3.85 3.84-3.85 8.46v615.38q0 4.62 3.85 8.46 3.84 3.85 8.46 3.85h455.38q4.62 0 8.46-3.85 3.85-3.84 3.85-8.46V-620H540ZM240-800v180-180V-160v-640Z" />
                      </svg>
                      CEUs
                    </Link>
                  </li>
                </ul>
              </div>
            </li>
          ) : (
            <></>
          )} */}

          {hasPermission('all.user') ? (
            <li>
              <Link
                to="/dashboard/message"
                className={
                  location.pathname === '/dashboard/message' ? 'active' : ''
                }
                onClick={closeSidebar}
              >
                <svg
                  stroke="currentColor"
                  fill="currentColor"
                  strokeWidth="0"
                  viewBox="0 0 16 16"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M2.678 11.894a1 1 0 0 1 .287.801 10.97 10.97 0 0 1-.398 2c1.395-.323 2.247-.697 2.634-.893a1 1 0 0 1 .71-.074A8.06 8.06 0 0 0 8 14c3.996 0 7-2.807 7-6 0-3.192-3.004-6-7-6S1 4.808 1 8c0 1.468.617 2.83 1.678 3.894zm-.493 3.905a21.682 21.682 0 0 1-.713.129c-.2.032-.352-.176-.273-.362a9.68 9.68 0 0 0 .244-.637l.003-.01c.248-.72.45-1.548.524-2.319C.743 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7-3.582 7-8 7a9.06 9.06 0 0 1-2.347-.306c-.52.263-1.639.742-3.468 1.105z"></path>
                  <path d="M4 5.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zM4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8zm0 2.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5z"></path>
                </svg>
                Message
              </Link>
            </li>
          ) : (
            <></>
          )}

          <li>
            <Link
              to="/dashboard/reviews"
              className={
                location.pathname === '/dashboard/reviews' ? 'active' : ''
              }
              onClick={closeSidebar}
            >
              <svg
                stroke="currentColor"
                fill="currentColor"
                strokeWidth="0"
                viewBox="0 0 16 16"
                height="1em"
                width="1em"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-2.5a2 2 0 0 0-1.6.8L8 14.333 6.1 11.8a2 2 0 0 0-1.6-.8H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2.5a1 1 0 0 1 .8.4l1.9 2.533a1 1 0 0 0 1.6 0l1.9-2.533a1 1 0 0 1 .8-.4H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"></path>
                <path d="M3 3.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM3 6a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9A.5.5 0 0 1 3 6zm0 2.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z"></path>
              </svg>
              Reviews
            </Link>
          </li>

          {/* <li>
            <Link
              to="/dashboard/saved-search"
              className={
                location.pathname === '/dashboard/saved-search' ? 'active' : ''
              }
            >
              <svg
                stroke="currentColor"
                fill="currentColor"
                strokeWidth="0"
                viewBox="0 0 16 16"
                height="1em"
                width="1em"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M6.5 4.482c1.664-1.673 5.825 1.254 0 5.018-5.825-3.764-1.664-6.69 0-5.018Z"></path>
                <path d="M13 6.5a6.471 6.471 0 0 1-1.258 3.844c.04.03.078.062.115.098l3.85 3.85a1 1 0 0 1-1.414 1.415l-3.85-3.85a1.007 1.007 0 0 1-.1-.115h.002A6.5 6.5 0 1 1 13 6.5ZM6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11Z"></path>
              </svg>
              Saved Search
            </Link>
          </li> */}
          {hasPermission('owner.tenant') ? (
            <li>
              <Link
                to="/dashboard/favorite"
                className={
                  location.pathname === '/dashboard/favorite' ? 'active' : ''
                }
                onClick={closeSidebar}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  height="24"
                  viewBox="0 -960 960 960"
                  width="24"
                >
                  <path d="m480-146.93-44.15-39.69q-99.46-90.23-164.5-155.07-65.04-64.85-103.08-115.43-38.04-50.57-53.15-92.27Q100-591.08 100-634q0-85.15 57.42-142.58Q214.85-834 300-834q52.38 0 99 24.5t81 70.27q34.38-45.77 81-70.27 46.62-24.5 99-24.5 85.15 0 142.58 57.42Q860-719.15 860-634q0 42.92-15.12 84.61-15.11 41.7-53.15 92.27-38.04 50.58-102.89 115.43Q624-276.85 524.15-186.62L480-146.93Zm0-81.07q96-86.38 158-148.08 62-61.69 98-107.19t50-80.81q14-35.3 14-69.92 0-60-40-100t-100-40q-47.38 0-87.58 26.88-40.19 26.89-63.65 74.81h-57.54q-23.85-48.31-63.85-75Q347.38-774 300-774q-59.62 0-99.81 40Q160-694 160-634q0 34.62 14 69.92 14 35.31 50 80.81t98 107q62 61.5 158 148.27Zm0-273Z" />
                </svg>
                My Favorites
              </Link>
            </li>
          ) : (
            <></>
          )}
          {/* {hasPermission('owner') && (
            <li>
              <Link
                to="/dashboard/calender"
                className={
                  location.pathname === '/dashboard/calender' ? 'active' : ''
                }
              >
                <svg
                  stroke="currentColor"
                  fill="currentColor"
                  strokeWidth="0"
                  viewBox="0 0 16 16"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"></path>
                </svg>
                Calender
              </Link>
            </li>
          )} */}
          {hasPermission('admin') ? (
            <li>
              <Link
                to="/dashboard/owner-package"
                className={
                  location.pathname === '/dashboard/owner-package'
                    ? 'active'
                    : ''
                }
                onClick={closeSidebar}
              >
                <span className="material-symbols-outlined">inventory_2</span>
                Owner Package
              </Link>
            </li>
          ) : (
            <></>
          )}
          {hasPermission('admin') ? (
            <li>
              <Link
                to="/dashboard/subscriber-email"
                className={
                  location.pathname === '/dashboard/subscriber-email'
                    ? 'active'
                    : ''
                }
                onClick={closeSidebar}
              >
                <span className="material-symbols-outlined">stacked_email</span>
                Subscribed Emails
              </Link>
            </li>
          ) : (
            <></>
          )}
          {hasPermission('admin') ? (
            <li>
              <Link
                to="/dashboard/policy"
                className={
                  location.pathname === '/dashboard/policy' ? 'active' : ''
                }
                onClick={closeSidebar}
              >
                <span className="material-symbols-outlined">gavel</span>
                Policy
              </Link>
            </li>
          ) : (
            <></>
          )}
          <li>
            <Link
              to="/dashboard/setting"
              className={
                location.pathname === '/dashboard/setting' ? 'active' : ''
              }
              onClick={closeSidebar}
            >
              <svg
                stroke="currentColor"
                fill="currentColor"
                strokeWidth="0"
                viewBox="0 0 1024 1024"
                height="1em"
                width="1em"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M960.496 415.056l-82.129-18.224c-6.4-20.48-14.784-40.08-24.4-58.927l44.431-74.032c16.592-26.512 24.976-65.52 0-90.512l-45.28-45.248c-24.976-24.992-67.151-20.496-92.623-2.832l-72.032 45.887c-18.689-9.696-38.225-18-58.529-24.56l-18.431-83.12C605.999 33.009 579.343 0 543.999 0h-64c-35.344 0-57.008 33.504-64 64l-20.528 82.128c-21.68 6.912-42.496 15.744-62.336 26.208l-73.84-47.024c-25.456-17.664-67.648-22.16-92.624 2.832l-45.264 45.248c-24.992 25.008-16.608 64 0 90.512l46.752 77.92c-8.767 17.664-16.544 35.936-22.544 55.024l-82.112 18.224C33.007 420.56 0 447.216 0 482.56v64c0 35.344 33.504 57.008 64 64l83.152 20.784c5.745 17.632 12.928 34.56 21.056 50.976l-46.8 78c-16.591 26.496-24.975 65.504 0 90.496l45.28 45.248c24.976 25.008 67.152 20.496 92.624 2.847l74-47.152c19.952 10.528 40.88 19.44 62.704 26.337L416.495 960c7.008 30.496 28.656 64 64 64h64c35.344 0 62-33.007 67.504-63.504l18.464-83.343c20.096-6.496 39.376-14.689 57.84-24.257l72.192 46c25.472 17.664 67.664 22.16 92.624-2.848L898.4 850.8c24.976-25.008 16.592-64 0-90.496l-44.463-74.128c8.944-17.568 16.688-35.84 22.912-54.848L960 610.56c30.496-7.008 64-28.656 64-64v-64c0-35.344-32.992-62-63.504-67.504zm-.465 126.992c-2.72 1.952-7.842 4.635-14.338 6.139l-118.656 29.631-11.008 33.632c-4.975 15.153-11.407 30.529-19.119 45.712l-16.064 31.569 62.688 104.528c4 6.4 5.872 12.127 6.432 15.503l-42.096 42.033c-4.064-1.28-8.688-2.945-10.912-4.464l-105.344-67.184-32.752 16.945c-15.776 8.192-31.969 14.976-48.097 20.192l-34.88 11.28-26.368 119.12c-1.216 6.368-4.624 11.504-6.96 13.344h-57.6c-1.951-2.72-4.623-7.84-6.112-14.32L449.39 827.9l-34.095-10.817c-17.569-5.536-35.088-12.912-52.144-21.904l-32.912-17.376-105.36 67.152c-4.304 2.912-8.912 4.56-13.088 4.56l-41.968-40.847c.56-3.311 2.304-8.783 5.792-14.367l65.456-109.056-15.568-31.344c-7.264-14.784-13.024-28.656-17.504-42.4l-10.992-33.664L79.518 548.46c-7.392-1.68-12.736-4.432-15.52-6.4v-59.504c.032.016.08.032.145.032 1.072 0 6.336-3.745 10.72-4.544l120.72-26.737 11.087-35.28c4.512-14.368 10.672-29.344 18.816-45.775l15.568-31.36-64.767-107.92c-4.016-6.432-5.872-12.16-6.432-15.52l42.08-42.065c4.08 1.312 8.672 2.96 10.88 4.48l107.312 68.4 32.88-17.344c16.88-8.895 34.336-16.239 51.904-21.823l34.016-10.832L478.11 79.501c1.697-7.391 4.416-12.735 6.4-15.52H544c-.433.657 3.68 6.24 4.527 10.865l26.88 121.408 34.848 11.264c16.336 5.28 32.752 12.16 48.72 20.448l32.752 17.008 103.152-65.712c4.32-2.945 8.944-4.576 13.088-4.576l42 40.816c-.56 3.328-2.32 8.816-5.808 14.416l-63.344 105.488 16.16 31.616c8.72 17.056 15.376 33.056 20.32 48.928l11.056 35.344L946.64 477.55c7.153 1.328 12.721 5.456 13.905 7.696zM512.43 319.674c-106.272 0-192.736 86.288-192.736 192.32 0 106.016 86.464 192.304 192.736 192.304s192.736-86.288 192.736-192.304c0-106.032-86.464-192.32-192.736-192.32zm-.432 320.32c-70.576 0-128-57.424-128-128 0-70.592 57.424-128 128-128 70.592 0 128 57.408 128 128 0 70.576-57.424 128-128 128z"></path>
              </svg>
              Profile Setting
            </Link>
          </li>
        </ul>
      </div>
    </aside>
  );
}

export default DashboardNavbar;
